module.exports = __webpack_public_path__ + "static/img/CH.c583f16a.svg";